:host {
  display: inline-block;
  max-width: 100%;
}

:host([size='small']) {
  line-height: 1.2rem;
}

.badge {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  text-align: center;

  max-width: 100%;
  height: var(--o2-spacing-5, #{$spacing-5});
  padding: 0 var(--o2-spacing-sm, #{$spacing-sm});
  border-radius: var(--o2-radius-md, #{$radius-md});

  background: var(--o2-badge-blue, #{$badge-blue});
  color: var(--o2-text-main-on-color, #{$text-main-on-color});

  font-size: 1.2rem;
  @include font-weight(600);
  line-height: 1.8rem;
  letter-spacing: 0.02rem;
}

.badge__text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.badge--small {
  height: 1.8rem;
}

.badge--yellow, .badge--orange {
  background: var(--o2-badge-yellow-promo, #{$badge-yellow-promo});
  color: var(--o2-text-main-primary, #{$text-main-primary});
}

.badge--frog {
  background: var(--o2-badge-frog-promo, #{$badge-frog-promo});
  color: var(--o2-text-main-primary, #{$text-main-primary});
}

.badge--purple, .badge--rose {
  background: var(--o2-badge-purple, #{$badge-purple});
}

.badge--brand {
  background: var(--o2-badge-brand, #{$badge-brand});
}
